var map = {
	"./add.png": 5377,
	"./alarm.png": 7107,
	"./battery.png": 9219,
	"./charts.png": 2533,
	"./company.png": 1213,
	"./confirmed.png": 6015,
	"./dark.png": 9130,
	"./dashboard.png": 4788,
	"./disconnected.png": 5339,
	"./door.png": 9082,
	"./download.png": 702,
	"./employees.png": 4275,
	"./emptyPort.png": 9690,
	"./events.png": 4449,
	"./filter.png": 9780,
	"./fire.png": 2238,
	"./firmware.png": 1333,
	"./history.png": 3804,
	"./humidity.png": 8913,
	"./inbox.png": 7176,
	"./koffer.png": 5761,
	"./light.png": 6276,
	"./location.png": 3783,
	"./logout.png": 6172,
	"./logs.png": 8435,
	"./mail.png": 9479,
	"./offline.png": 389,
	"./ok.png": 7244,
	"./online.png": 5079,
	"./restart.png": 4797,
	"./settings.png": 8393,
	"./signal.png": 970,
	"./sms.png": 471,
	"./status.png": 3716,
	"./temperature.png": 4238,
	"./time.png": 1013,
	"./user.png": 9147,
	"./uuid.png": 7939,
	"./warning.png": 5876
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7031;